import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ReaktivirajSadrzajSluzbeneEvidencijeCommand, ReaktivirajSluzbenuEvidencijuCommand, SluzbenaEvidencijaClient } from 'app/api/iop-metaregistar-api-reference';
import moment from 'moment';

@Component({
  selector: 'app-reaktivacija-popup',
  templateUrl: './reaktivacija-popup.component.html',
  styleUrls: ['./reaktivacija-popup.component.scss']
})
export class ReaktivacijaPopupComponent implements OnInit {
  translatePrefix: string = "features.sluzbenaEvidencija.osnovniPodaci.";
  errorPrefix: string = "errors.";
  successPrefix: string = "successes.";

  unos: FormGroup;
  minDate: any;

  reaktivacijaSE: boolean = false;
  reaktivacijaSadrzaja: boolean = false;

  constructor(private fb: FormBuilder,
    private matSnack: MatSnackBar,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ReaktivacijaPopupComponent>,
    private seService: SluzbenaEvidencijaClient,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, podaci: any }) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    let danasnjiDatum = new Date();
    this.minDate = new Date(this.data.podaci.datumOd);
    if (moment(this.minDate).startOf("day") < moment(danasnjiDatum).startOf("day")) this.minDate = danasnjiDatum;

    this.minDate.setDate(this.minDate.getDate() + 1);

    this.unos = this.fb.group({
      vaziOd: new FormControl<any>(this.minDate, [Validators.required])
    })

    if (this.data.podaci.sifra) {
      this.reaktivacijaSE = true;
    } else {
      this.reaktivacijaSadrzaja = true;
    }
  }

  cancel() {
    this.dialogRef.close()
  }

  confirm(event: any) {
    if (this.unos.invalid) return;
    if (this.reaktivacijaSE) {
      this.reaktivirajSE();
    } else {
      this.reaktivirajSadrzaj();
    }
  }

  reaktivirajSE() {
    this.seService.reaktivirajSluzbenuEvidenciju(new ReaktivirajSluzbenuEvidencijuCommand({
      sifra: this.data.podaci.sifra,
      datumOd: this.vaziOd.value
    })).subscribe(res => {
      if (res.responseBool) {
        this.matSnack.open(this.translate.instant(this.successPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'successSnack' });
        this.dialogRef.close(true);
      } else {
        this.matSnack.open(this.translate.instant(this.errorPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'errorSnack' });
        this.dialogRef.close(false);
      }
    })
  }

  reaktivirajSadrzaj() {
    this.seService.reaktivirajSadrzaj(new ReaktivirajSadrzajSluzbeneEvidencijeCommand({
      sifra: this.data.podaci.sifraSadrzaja,
      datumOd: this.vaziOd.value
    })).subscribe(res => {
      if (res.responseBool) {
        this.matSnack.open(this.translate.instant(this.successPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'successSnack' });
        this.dialogRef.close(true);
      } else {
        this.matSnack.open(this.translate.instant(this.errorPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'errorSnack' });
        this.dialogRef.close(false);
      }
    })
  }

  get vaziOd() {
    return this.unos.get('vaziOd');
  }
}
